import React, { useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { formatDate } from '../../../apps/professional-app/fa/common/aifeatures/utils'

import { selectCurrentUserEmailIntegration } from '../../../store/emailHub/emailUsers'
import { selectNewEmailResult } from '../../../store/emailHub/newEmail'
import { useAppSelector } from '../../../store/hooks'

import { Button } from '../../../components/Button/Button'

import { isNewEmailNoResult } from '../NewEmail/utils'
import { getConnectorIcon } from '../utils'

import './EmailHeader.scss'

export interface NewEmailHeaderProps {}

export const NewEmailHeader: React.FC<NewEmailHeaderProps> = () => {
  const navigate = useNavigate()

  const newEmailResult = useAppSelector(selectNewEmailResult)
  const emailIntegration = useAppSelector(selectCurrentUserEmailIntegration)

  const isNoResult = useMemo(() => isNewEmailNoResult(newEmailResult), [newEmailResult])
  const currentDate = useMemo(() => formatDate(new Date().toISOString()), [])

  const [searchParams] = useSearchParams()

  const handleBackButtonClicked = () => {
    const contactId = searchParams.get('contactId')
    navigate(contactId ? `/library/manage-contacts/contacts/${contactId}` : '/email/inbox')
  }

  return (
    <div className='d-flex gap-3 align-items-center zocks-pl-2.0'>
      <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
        <i className='bi bi-chevron-left' />
      </Button>
      <div className='d-flex align-items-center justify-content-center zocks-border-0.25 zocks-bg-color-gray-200 email-connector-icon '>
        {getConnectorIcon(emailIntegration)}
      </div>
      <div className='d-flex flex-column'>
        <div className='paragraph-large bold'>{!newEmailResult || isNoResult ? 'New email' : newEmailResult.subject}</div>
        <div className='d-flex gap-3'>
          <div className='d-flex gap-2 align-items-center'>
            <i className='bi bi-calendar4' />
            <div className='paragraph-small zocks-text-gray-600'>{currentDate}</div>
            {emailIntegration?.email ? (
              <div className='d-flex gap-2 align-items-center'>
                <i className='bi bi-inbox' />
                <div className='paragraph-small zocks-text-gray-600'>{emailIntegration.email}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
